/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { InputAction } from "../../enums/InputAction";
import type { TInputEvent, InputInterceptor } from "../types/TInputEvent";

/**
 * Throttles SCROLL_UP and SCROLL_DOWN events to prevent excessive
 * scroll handling on mouse wheel or trackpad. Events arriving within
 * `intervalMs` of the previous scroll event are consumed (blocked).
 */
export function createScrollThrottleInterceptor(
  intervalMs: number
): InputInterceptor {
  let lastScrollTime: number = 0;

  return (event: TInputEvent): boolean | void => {
    if (
      event.action === InputAction.SCROLL_UP ||
      event.action === InputAction.SCROLL_DOWN
    ) {
      const now = event.timestamp;
      if (now - lastScrollTime < intervalMs) {
        return true;
      }
      lastScrollTime = now;
    }
  };
}
